var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBinanceCoinSeeklogocom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.331,
    height: 27.331,
    viewBox: "0 0 27.331 27.331",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "binance-coin-seeklogo.com",
    transform: "translate(-0.006)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36546",
    "data-name": "Path 36546",
    d: "M8.364,11.485l5.308-5.308,5.31,5.31L22.07,8.4,13.671,0l-8.4,8.4,3.088,3.088M.006,13.665l3.089-3.089,3.088,3.088L3.094,16.754Zm8.358,2.181,5.308,5.308,5.31-5.31,3.09,3.087,0,0-8.4,8.4-8.4-8.4,0,0,3.093-3.084m12.8-2.18,3.089-3.089,3.088,3.088-3.089,3.089Z",
    fill: "#bfc9d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36547",
    "data-name": "Path 36547",
    d: "M776.818,773.684h0l-3.134-3.134-2.316,2.316h0l-.266.266-.549.549,0,0,0,0,3.131,3.131,3.134-3.134,0,0h0",
    transform: "translate(-760.014 -760.02)",
    fill: "#bfc9d1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinanceCoinSeeklogocom);
export default __webpack_public_path__ + "static/media/binance-coin-seeklogo.com.0bdaa40d.svg";
export { ForwardRef as ReactComponent };